<script lang="ts">
    import { defineComponent } from "vue"
    import { DocumentReviewStatusTypes } from "../Enums/ChoiceEnums"

    export default defineComponent({
        name: "ChoiceDocumentReviewStatus",

        props: {
            reviewStatus: Number,
            reviewStatusDesc: String
        },

        computed:{
            iconClass()
            {
                if (DocumentReviewStatusTypes.PendingReview == this.reviewStatus)
                    return "fa-solid fa-triangle-exclamation text-warning";
                if (DocumentReviewStatusTypes.ReviewCompleted == this.reviewStatus)
                    return "fa-regular fa-circle-check text-success";
            }
        }
    });
</script>

<template>
    <span v-if="!reviewStatus" class="text-muted">
        <i class="fa-regular fa-circle-question" aria-hidden="true"></i>
        Unassigned
    </span>
    <span v-else>
        <i :class="iconClass" aria-hidden="true" v-if="iconClass"></i>
        {{reviewStatusDesc}}
    </span>
</template>